import { z } from 'zod';
import { RECORD_KIND_NAMES } from '../record-kinds.js';
/** Trường ảnh gốc được tách khỏi `data` và phục vụ qua đường dẫn riêng. */
export const RECORD_IMAGE_FIELDS = ['thumb'];
const recordKindSchema = z.enum(RECORD_KIND_NAMES);
/**
 * Ảnh trong một thao tác ghi, theo từng trường:
 *   vắng mặt        → giữ nguyên ảnh đang lưu
 *   chuỗi data-URL  → người dùng vừa dán ảnh mới, ghi đè
 *   null            → người dùng bấm bỏ ảnh, xoá thật
 */
const imageChangesSchema = z
    .partialRecord(z.enum(RECORD_IMAGE_FIELDS), z.string().startsWith('data:').nullable())
    .optional();
const putOperationSchema = z.object({
    op: z.literal('put'),
    kind: recordKindSchema,
    /** Có `id` → cập nhật; không có → tạo mới. */
    id: z.number().int().positive().optional(),
    data: z.record(z.string(), z.unknown()),
    images: imageChangesSchema,
    /** Cấp trên tạo bản ghi THAY CHO cấp dưới (chỉ trong phạm vi nhìn của mình). */
    owner: z.string().optional(),
});
const deleteOperationSchema = z.object({
    op: z.literal('delete'),
    kind: recordKindSchema,
    id: z.number().int().positive(),
});
export const recordOperationSchema = z.discriminatedUnion('op', [
    putOperationSchema,
    deleteOperationSchema,
]);
export const MAX_BATCH_OPERATIONS = 500;
export const recordBatchRequestSchema = z.object({
    operations: z.array(z.unknown()).max(MAX_BATCH_OPERATIONS),
});
//# sourceMappingURL=records.js.map